import React from 'react'

type Intro = {
    title: string
    descriptionComponent: () => JSX.Element
}

type StatItemProps = {
    faIconClasses: string
    metricText: string
    metricDescription: string
}

type StatisticsBarProps = {
    intro?: Intro
    statItems: Array<StatItemProps>
}

export const StatisticsBar = ({ intro = null, statItems = [] }: StatisticsBarProps) => {
    return (
        <section
            className={`bg-statbar-pattern py-1 md:py-4 lg:pl-14 w-full ${
                intro ? 'grid grid-cols-auto-2 lg:grid-cols-auto-1 md:gap-6' : ''
            }`}
        >
            {intro && (
                <div className="md:max-w-2xl lg:max-w-xl py-5 px-4 sm:px-0 md:px-14 lg:px-0">
                    <h4 className="mb-2 text-2xl md:text-4xl text-white">
                        {intro.title}
                    </h4>
                    <div>{intro.descriptionComponent()}</div>
                </div>
            )}

            <div
                className={`flex justify-around flex-row flex-wrap  ${
                    intro ? 'sm:px-16 px-4' : 'md:px-8 mx-auto'
                }`}
            >
                {statItems.map((item, idx) => (
                    <div
                        key={idx}
                        className="flex items-center justify-center flex-col my-2 md:my-5 px-1 md:px-3 lg:px-10"
                    >
                        <i
                            aria-hidden
                            className={`${item.faIconClasses} text-4xl md:text-6xl leading-none text-yf-green-700 mb-1`}
                        ></i>
                        <p className="text-white sm:text-2xl font-medium">
                            {item.metricText}
                        </p>
                        <p className="text-white text-center text-xs lg:text-lg font-extralight uppercase">
                            {item.metricDescription}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    )
}
